<template>
    <figure :class="classes" :style="styles">
        <vector-icon
            v-if="useVectorIcon"
            :icon="contact.icon"
            :fill="contact.fill"
            :size="sizeIcon"
            clearMargin="clearMargin"
        />
        <img v-else-if="isAvatar" :src="src" alt="" />
        <fa-icon v-else-if="contact.icon" :icon="contact.icon" />
        <template v-else>{{ text }}</template>
    </figure>
</template>

<script>
import InitialsMixin from 'mixins/initials';

export default {
    mixins: [InitialsMixin],

    props: {
        contact: {
            type: Object,
            required: true,
        },
        size: {
            type: Number,
            default: 32,
            validator(value) {
                return (
                    [
                        16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 30, 31, 32, 33, 34, 35, 36, 40, 48,
                        54, 60, 64,
                    ].indexOf(value) !== -1
                );
            },
        },
        useVectorIcon: { type: Boolean, default: false },
        sizeIcon: { type: Number, default: 16 },
    },

    computed: {
        isAvatar() {
            return this.photoUrl && !this.isDefaultAvatar;
        },

        isShort() {
            return this.size < 24;
        },

        photoUrl() {
            return this.contact.photo_url || this.contact.photoUrl;
        },

        isSalesMsg() {
            return Boolean(
                this.contact.email === 'support@salesmessage.com' ||
                    this.contact.email === 'salesmessage@gmail.com'
            );
        },

        classes() {
            return [
                'image',
                `is-${this.size}x${this.size}`,
                this.isAvatar ? 'is-avatar' : 'avatar-initials',
                `${this.isSalesMsg ? 'salesmessage-avatar' : ''}`,
            ];
        },

        text() {
            return this.isSalesMsg ? '' : this.initials(this.contact, this.isShort) || '#';
        },

        styles() {
            let backgroundColor = '';
            if ((!this.isAvatar && !this.contact.icon) || this.useVectorIcon) {
                backgroundColor = this.contact.color;
                if (!backgroundColor) {
                    const palette = [
                        '#6372A5',
                        '#1D95F2',
                        '#10D0AD',
                        '#E13466',
                        '#FFC422',
                        '#FF9423',
                        '#A233E1',
                    ];

                    backgroundColor = palette[this.contact.id % palette.length];
                }
            }

            return {
                backgroundColor,
            };
        },

        src() {
            if (!this.isAvatar) {
                return false;
            }

            if (this.photoUrl.indexOf('gravatar') !== -1) {
                return `${this.photoUrl}&s=${this.size * 2}`;
            }

            return this.photoUrl;
        },

        isDefaultAvatar() {
            if (!this.photoUrl) return false;

            return this.photoUrl.includes(
                `${window.location.hostname}/images/app/default-avatar.png`
            );
        },
    },
};
</script>
